module.exports = __webpack_public_path__ + "img/water-testing-website-2nd-pic.a629a291.jpg";